import HttpRequest from './axios'

const axios = new HttpRequest()
export default axios
